/**
* Mock data object
* It will be replaced when the API is finished
*/

import BoxWithBorder from "../components/BoxWithBorder";
import Button from "../components/Button";

const imageSrc = `${window._env_.STATIC_HOST}/static/website/images/camioneta.png`;

const toastConfig = { autoClose: 2000, hideProgressBar: false, theme: "dark" };

const mock = {
    imageSrc: imageSrc,

    iconSources: {
        maintenance: `${window._env_.STATIC_HOST}/static/website/images/icon-maintenance.svg`,
        accessory: `${window._env_.STATIC_HOST}/static/website/images/icon-accessory.svg`,
        merchandise: `${window._env_.STATIC_HOST}/static/website/images/icon-merchandise.svg`,
        discount: `${window._env_.STATIC_HOST}/static/website/images/icon-discount.svg`

    },

    items: {
        // Accesorios
        accesorios: [
            {
                id: "kitParachoquesDelantero",
                type: "accessory",
                slug: "kit-parachoques-delantero",

                title: "Kit Parachoques Delantero",
                subtitle: "Esto es un kit de parachoques delantero",
                detailSubtitle: "",

                image: imageSrc,
                secondaryImage: "",

                currency: "CL",
                price: 1000.0,
                stock: 0,
                discount: "",

                isClickable: true,

                itemType: "sedan",
                itemModel: "se",
                itemVersion: "se100",

                versionPrices: {
                    "sedan-se-se100": {
                        price: 100,
                        installation: 200,
                    },
                    "coupe-fb-fb200": {
                        price: 200,
                        installation: 500,
                    },
                    "suv-ux-100": {
                        price: 400,
                        installation: 1000,
                    },
                },

                description: {
                    type: "list",
                    title: "Descripción",
                    items: [
                        "Lorem ipsum dolor sit amet consectetur, adipisicing elit. A, beatae omnis ipsum sequi quibusdam aspernatur ex velit ea molestiae consectetur libero repudiandae nobis neque voluptates ratione dolor inventore itaque. Dolorum!",
                        "Lorem ipsum dolor sit amet consectetur, adipisicing elit. A, beatae omnis ipsum sequi quibusdam aspernatur ex velit ea molestiae consectetur libero repudiandae nobis neque voluptates ratione dolor inventore itaque. Dolorum!",
                        "Lorem ipsum dolor sit amet consectetur, adipisicing elit. A, beatae omnis ipsum sequi quibusdam aspernatur ex velit ea molestiae consectetur libero repudiandae nobis neque voluptates ratione dolor inventore itaque. Dolorum!",
                        "Lorem ipsum dolor sit amet consectetur, adipisicing elit. A, beatae omnis ipsum sequi quibusdam aspernatur ex velit ea molestiae consectetur libero repudiandae nobis neque voluptates ratione dolor inventore itaque. Dolorum!",
                    ]
                },

                legalInfo: {
                    texts: [
                        "(*) Precios sugeridos.Valores de consumo de combustible han sido obtenidos en mediciones de laboratorio según ciclo de ensayo de la comunidad europea, homologadas en el mtt.Más información: www.Consumovehicular.Cl para ver los términos y condiciones de los modelos y sus versiones, diríjase a los términos y condiciones generales en cada modelo publicado o en la siguiente sección: www.Toyota.Cl / terminos - y - condiciones - comerciales - por - modelo /",
                        "(**) Acceda a precios preferenciales en el valor de las mantenciones a través de su compra online en tienda.Toyota.Cl.Precios preferenciales con rebajas de hasta 20 % sobre el precio referencial comprando 4 o más mantenciones.Ejemplo: valor referencial cuatro mantenciones(10k, 20k, 30k, 40k) rav4 = $.1089.960 valor compra online = $871.968.Precios preferenciales no aplican para otras formas ni canales de pago.Para conocer precios preferenciales por compras online de mantenciones individuales o paquetes, consulte en tienda.Toyota.Cl.El precio de cada mantención prepagada(mpp) incluye iva, repuestos, insumos, mano de obra.No incluyen reparaciones, trabajos ni cambio de piezas fuera del plan de mantenimiento del vehículo.El plan de mantenimiento se encuentra en el manual de garantía y servicio del vehículo."
                    ]
                },

                inputs: {
                    dropdown: {
                        dropdownItems: [
                            {
                                label: "Coupe FB FB200",
                                dataValue: "coupe-fb-fb200",
                                isSelected: false,
                            },
                            {
                                label: "Sedan SE SE100",
                                dataValue: "sedan-se-se100",
                                isSelected: false
                            },
                        ]
                    },
                },
            }
        ],

        // Mantenciones
        mantenciones: [
            {
                id: "mantencionIS300FSport",
                type: "maintenance",
                slug: "mantencion-is-300-f-sport",

                title: "Mantención IS 300 F Sport",
                subtitle: "Aventuras urbanas en un paquete hibrido",
                detailSubtitle: "Opcional",
                image: imageSrc,
                secondaryImage: "",

                discount: "Obtén 10% comprando 2 unidades, 15% comprando 3 unidades o 20% por compras de 4 o más.",

                isClickable: true,

                itemType: "suv",
                itemModel: "ux",
                itemVersion: "100",

                forItems: ["suv-ux-100"],

                versionPrices: {
                    "mantencion-10000-km": {
                        price: 100,
                    },
                    "mantencion-20000-km": {
                        price: 200,
                    },
                    "mantencion-30000-km": {
                        price: 400,
                    },
                },

                description: {
                    type: "",
                    title: "Descripción",
                    items: [
                        "Lorem ipsum dolor sit amet consectetur, adipisicing elit. A, beatae omnis ipsum sequi quibusdam aspernatur ex velit ea molestiae consectetur libero repudiandae nobis neque voluptates ratione dolor inventore itaque. Dolorum!",
                        "Lorem ipsum dolor sit amet consectetur, adipisicing elit. A, beatae omnis ipsum sequi quibusdam aspernatur ex velit ea molestiae consectetur libero repudiandae nobis neque voluptates ratione dolor inventore itaque. Dolorum!",
                        "Lorem ipsum dolor sit amet consectetur, adipisicing elit. A, beatae omnis ipsum sequi quibusdam aspernatur ex velit ea molestiae consectetur libero repudiandae nobis neque voluptates ratione dolor inventore itaque. Dolorum!",
                        "Lorem ipsum dolor sit amet consectetur, adipisicing elit. A, beatae omnis ipsum sequi quibusdam aspernatur ex velit ea molestiae consectetur libero repudiandae nobis neque voluptates ratione dolor inventore itaque. Dolorum!",
                    ]
                },
                legalInfo: {
                    texts: [
                        "(*) Precios sugeridos.Valores de consumo de combustible han sido obtenidos en mediciones de laboratorio según ciclo de ensayo de la comunidad europea, homologadas en el mtt.Más información: www.Consumovehicular.Cl para ver los términos y condiciones de los modelos y sus versiones, diríjase a los términos y condiciones generales en cada modelo publicado o en la siguiente sección: www.Toyota.Cl / terminos - y - condiciones - comerciales - por - modelo /",
                        "(**) Acceda a precios preferenciales en el valor de las mantenciones a través de su compra online en tienda.Toyota.Cl.Precios preferenciales con rebajas de hasta 20 % sobre el precio referencial comprando 4 o más mantenciones.Ejemplo: valor referencial cuatro mantenciones(10k, 20k, 30k, 40k) rav4 = $.1089.960 valor compra online = $871.968.Precios preferenciales no aplican para otras formas ni canales de pago.Para conocer precios preferenciales por compras online de mantenciones individuales o paquetes, consulte en tienda.Toyota.Cl.El precio de cada mantención prepagada(mpp) incluye iva, repuestos, insumos, mano de obra.No incluyen reparaciones, trabajos ni cambio de piezas fuera del plan de mantenimiento del vehículo.El plan de mantenimiento se encuentra en el manual de garantía y servicio del vehículo."
                    ]
                },
                mantenciones: [
                    {
                        label: "Mantención de los 10.000kms",
                        dataValue: "mantencion-10000-km",
                        isSelected: true
                    },
                    {
                        label: "Mantención de los 20.000kms",
                        dataValue: "mantencion-20000-km",
                        isSelected: false
                    },
                    {
                        label: "Mantención de los 30.000kms",
                        dataValue: "mantencion-30000-km",
                        isSelected: false
                    },
                ]
            }
        ],

        // Merchandising
        merchandising: [
            {
                id: "merchandisignRemera",
                type: "merchandise",
                slug: "remera-lexus",

                title: "Remera Lexus",
                subtitle: "Aventuras urbanas en un paquete hibrido",
                detailSubtitle: "Opcional",

                image: imageSrc,
                secondaryImage: "",

                price: 1000,

                discount: "",

                itemType: "indumentaria",
                itemModel: null,
                itemVersion: null,

                isClickable: true,

                description: {
                    type: "",
                    items: [
                        "Lorem ipsum dolor sit amet consectetur, adipisicing elit. A, beatae omnis ipsum sequi quibusdam aspernatur ex velit ea molestiae consectetur libero repudiandae nobis neque voluptates ratione dolor inventore itaque. Dolorum!",
                        "Lorem ipsum dolor sit amet consectetur, adipisicing elit. A, beatae omnis ipsum sequi quibusdam aspernatur ex velit ea molestiae consectetur libero repudiandae nobis neque voluptates ratione dolor inventore itaque. Dolorum!",
                        "Lorem ipsum dolor sit amet consectetur, adipisicing elit. A, beatae omnis ipsum sequi quibusdam aspernatur ex velit ea molestiae consectetur libero repudiandae nobis neque voluptates ratione dolor inventore itaque. Dolorum!",
                        "Lorem ipsum dolor sit amet consectetur, adipisicing elit. A, beatae omnis ipsum sequi quibusdam aspernatur ex velit ea molestiae consectetur libero repudiandae nobis neque voluptates ratione dolor inventore itaque. Dolorum!",
                    ]
                },
                legalInfo: {
                    texts: [
                        "(*) Precios sugeridos.Valores de consumo de combustible han sido obtenidos en mediciones de laboratorio según ciclo de ensayo de la comunidad europea, homologadas en el mtt.Más información: www.Consumovehicular.Cl para ver los términos y condiciones de los modelos y sus versiones, diríjase a los términos y condiciones generales en cada modelo publicado o en la siguiente sección: www.Toyota.Cl / terminos - y - condiciones - comerciales - por - modelo /",
                        "(**) Acceda a precios preferenciales en el valor de las mantenciones a través de su compra online en tienda.Toyota.Cl.Precios preferenciales con rebajas de hasta 20 % sobre el precio referencial comprando 4 o más mantenciones.Ejemplo: valor referencial cuatro mantenciones(10k, 20k, 30k, 40k) rav4 = $.1089.960 valor compra online = $871.968.Precios preferenciales no aplican para otras formas ni canales de pago.Para conocer precios preferenciales por compras online de mantenciones individuales o paquetes, consulte en tienda.Toyota.Cl.El precio de cada mantención prepagada(mpp) incluye iva, repuestos, insumos, mano de obra.No incluyen reparaciones, trabajos ni cambio de piezas fuera del plan de mantenimiento del vehículo.El plan de mantenimiento se encuentra en el manual de garantía y servicio del vehículo."
                    ]
                },
            },
        ],

        // Modelos
        modelos: [
            {
                id: "suv-ux-100",
                type: "modelo",
                slug: "suv-ux-100",

                title: "SUV UX 100",
                subtitle: "Aventuras urbanas en un paquete hibrido",
                detailSubtitle: "2023. Color Gris.",

                image: imageSrc,
                secondaryImage: imageSrc,

                stock: 0,
                price: 1000,

                isClickable: true,
                isHighlighted: true,

                itemType: "suv",
                itemModel: "ux",
                itemVersion: "100",
                itemColors: ["red"],
                itemBookPrice: 20000,

                description: {
                    // type: "car",
                    items: [
                        {
                            bigText: "241 hp",
                            smallText: "Potencia"
                        },
                        {
                            bigText: "12,2 km/l",
                            smallText: "Consumo de combustible"
                        },
                        {
                            bigText: "7.0 sec",
                            smallText: "Potencia"
                        }
                    ]
                },
                extraInfo: {
                    cash: {
                        currency: "USD",
                        price: 10000,
                    },
                    financing: {
                        currency: "CLP",
                        price: 200000,
                        label: "Cuota mensual (36 cuotas)",
                        cae: "13.8%",
                        valorDelPie: 10000,
                        cuotaFinalPlan: 20000,
                        cuotaTotalCredito: 20000,
                    }
                },
                legalInfo: {
                    texts: [
                        "(*) Precios sugeridos.Valores de consumo de combustible han sido obtenidos en mediciones de laboratorio según ciclo de ensayo de la comunidad europea, homologadas en el mtt.Más información: www.Consumovehicular.Cl para ver los términos y condiciones de los modelos y sus versiones, diríjase a los términos y condiciones generales en cada modelo publicado o en la siguiente sección: www.Toyota.Cl / terminos - y - condiciones - comerciales - por - modelo /",
                        "(**) Acceda a precios preferenciales en el valor de las mantenciones a través de su compra online en tienda.Toyota.Cl.Precios preferenciales con rebajas de hasta 20 % sobre el precio referencial comprando 4 o más mantenciones.Ejemplo: valor referencial cuatro mantenciones(10k, 20k, 30k, 40k) rav4 = $.1089.960 valor compra online = $871.968.Precios preferenciales no aplican para otras formas ni canales de pago.Para conocer precios preferenciales por compras online de mantenciones individuales o paquetes, consulte en tienda.Toyota.Cl.El precio de cada mantención prepagada(mpp) incluye iva, repuestos, insumos, mano de obra.No incluyen reparaciones, trabajos ni cambio de piezas fuera del plan de mantenimiento del vehículo.El plan de mantenimiento se encuentra en el manual de garantía y servicio del vehículo."
                    ]
                },
                buttons: [],
                inputs: {
                    dropdown: {
                        dropdownItems: [
                            {
                                label: "Concesionario 1",
                                dataValue: "concesionario-1",
                                isSelected: false
                            },
                            {
                                label: "Concesionario 2",
                                dataValue: "concesionario-2",
                                isSelected: false
                            },
                            {
                                label: "Concesionario 3",
                                dataValue: "concesionario-3",
                                isSelected: false
                            },
                        ]
                    },
                }
            },
        ]
    }
}

const cartItems = [
    {
        id: 1,
        type: "maintenance",
        hasBackground: true,
        hasControls: true,
        image: imageSrc,
        title: "Mantencion Lexus Modelo F",
        description: "Descripción",
        quantity: 1,
        currency: "CL",
        price: 100,
        totalPrice: 0,
    },
    {
        id: 2,
        type: "accessory",
        image: imageSrc,
        hasControls: true,
        title: "Kit Deportivo",
        description: "Descripción",
        quantity: 1,
        currency: "CL",
        price: 150000,
        totalPrice: 0,
    },
    {
        id: 3,
        type: "merchandise",
        image: imageSrc,
        hasControls: true,
        title: "Llavero",
        description: "Descripción",
        quantity: 5,
        currency: "CL",
        price: 150000,
        totalPrice: 0,
    },
    {
        id: 4,
        type: "merchandise",
        image: imageSrc,
        hasControls: true,
        title: "Chomba",
        description: "Descripción",
        quantity: 1,
        currency: "CL",
        price: 150000,
        totalPrice: 0,
    },
    {
        id: 5,
        type: "maintenance",
        hasBackground: true,
        hasControls: true,
        image: imageSrc,
        title: "Mantencion Lexus Modelo X",
        description: "Descripción",
        quantity: 1,
        currency: "CL",
        price: 200,
        totalPrice: 0,
    },
]

export {
    mock,
    cartItems,
    toastConfig
}